import React, { Suspense } from 'react'
import { Container, Row, Col } from '@paypalcorp/pp-react'
import { useAppContext } from '../../contexts/app-context'
import useTracking from '../../hooks/useTracking'
import { componentNames } from '../../utils/analytics/fpti-constants'

// Components
import TopicTree from '../../components/topic-tree'
import HeroModule from '../../components/hero-module'
import MoreWaysOfHelp from '../../components/more-ways-of-help'
import LoginPrompt from '../../components/login-prompt'
import Survey from '../../components/survey'
import RecommendedSolutions from '../../components/recommended-solutions'

// styles
import '../../styles/pages/home.less'

// Home page - This is the page/container for home view which will have the layout and components placement
function Home() {
  const appCtx = useAppContext()
  const { trackActivity, fptiTypeByStatusCode } = useTracking()
  const { pageProps, reqContextData } = appCtx
  const { apiData } = pageProps
  const { topicTree, helpChannels, recommendedSolutions } = apiData
  const { isLoggedIn } = reqContextData

  // Error fpti event when service error happens
  const fireErrorFPTI = (errorData, componentName) => {
    const { isError, statusCode } = errorData
    const type = isError && fptiTypeByStatusCode(statusCode)
    trackActivity({ name: componentName, type })
    return <></>
  }

  // render RecommendedSolutions component when valid data from service, otherwise fire an error fpti event
  const renderRecommendedSolutions = () => {
    return recommendedSolutions &&
      recommendedSolutions.data &&
      recommendedSolutions.data.length > 0 ? (
      <RecommendedSolutions
        recommendedSolutionsData={recommendedSolutions.data}
      />
    ) : (
      fireErrorFPTI(recommendedSolutions, componentNames.RECOMMENDED_SOLUTIONS)
    )
  }

  // TODO: Home page validations will be added later when we start on the Home page implementation
  return (
    <>
      <Suspense fallback={<span>Loading...</span>}>
        <HeroModule />
      </Suspense>

      <Container>
        <Row className="home__header">
          <Col
            xs={{ span: 12, order: 3 }}
            sm={{ span: 12, order: 3 }}
            md={{ span: 4, order: 1 }}
          >
            <TopicTree topicTreeData={topicTree.data} />
          </Col>
          <Col
            xs={{ span: 12, order: 1 }}
            sm={{ span: 12, order: 1 }}
            md={{ span: 5, order: 2 }}
          >
            {renderRecommendedSolutions()}
          </Col>
          <Col
            xs={{ span: 12, order: 2 }}
            sm={{ span: 12, order: 2 }}
            md={{ span: 3, order: 3 }}
          >
            {!isLoggedIn && <LoginPrompt />}
          </Col>
        </Row>
        <Row>
          <MoreWaysOfHelp helpChannels={helpChannels.data} />
        </Row>
        <Row>
          <Survey />
        </Row>
      </Container>
    </>
  )
}

export default Home
